import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms'
import { toFormControl } from '@core/utils/form-utils'
import { AlbertDatepickerComponent } from '@shared/components/albert-datepicker/albert-datepicker.component'

@Component({
  selector: 'albert-period',
  standalone: true,
  imports: [ReactiveFormsModule, AlbertDatepickerComponent],
  templateUrl: './albert-period.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlbertPeriodComponent {
  public readonly periodFromGroupName = input.required<string>()
  public readonly periodToGroupName = input.required<string>()
  public readonly periodFromLabel = input<string>('Period From')
  public readonly periodToLabel = input<string>('PeriodTo')
  public readonly periodFromInputId = input.required<string>()
  public readonly periodToInputId = input.required<string>()
  public readonly disabled = input<boolean>(false)
  public readonly required = input<boolean>(false)
  public readonly controlName = input<string>('value')

  private readonly parentGroupDir = inject(FormGroupDirective)

  public readonly periodFromControl = computed(() => {
    const groupOrControl = this.parentGroupDir.form.get(this.periodFromGroupName())
    if (groupOrControl instanceof FormControl) {
      return groupOrControl
    }
    return toFormControl(groupOrControl?.get(this.controlName()))
  })

  public readonly periodToControl = computed(() => {
    const groupOrControl = this.parentGroupDir.form.get(this.periodToGroupName())
    if (groupOrControl instanceof FormControl) {
      return groupOrControl
    }
    return toFormControl(groupOrControl?.get(this.controlName()))
  })

}
